module.exports = {
    viasName: () => {
        return[
            ["Vieja vía Caldas", "Variante Caldas","Calle 100", "Río Medellín"]
        ]
    }
}